import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import React, { useState } from "react";
import { Button } from "react-admin";
import AcceptButton from "./AcceptButton";
import DeclineButton from "./DeclineButton";
import { StyledButton } from "../../../components/ListShowButton";
import DoneIcon from "@material-ui/icons/Done";

export interface IConfirmCcaStudentRenewalButton {
  id: number;
  studentId: number;
  ccaAcademicYearId: number;
  school?: ISchool;
  history?: any;
}

export const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  dialogSetDate: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
      bottom: 40,
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const ConfirmCcaStudentRenewalButton = ({
  id,
  studentId,
  ccaAcademicYearId,
  school,
  history,
}: IConfirmCcaStudentRenewalButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Update CCA Renewal Status
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Update CCA Renewal Status
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Choose Accept for accepting the student for renewal CCA schedule or
            Decline for declining the student for renewal CCA schedule.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            label="Back"
            style={{ backgroundColor: "#9e9e9e" }}
          />
          <DeclineButton
            id={id}
            studentId={studentId}
            ccaAcademicYearId={ccaAcademicYearId}
          />
          {!school?.isAllowParentUpdateScheduleWhenRenewal && (
            <AcceptButton
              id={id}
              studentId={studentId}
              ccaAcademicYearId={ccaAcademicYearId}
            />
          )}

          {school?.isAllowParentUpdateScheduleWhenRenewal && history && (
            <Button
              onClick={() =>
                history.push(
                  `/approveCcaStudentRenewalWithSchedules/create?source=${JSON.stringify(
                    {
                      studentId: Number(studentId),
                      ccaAcademicYearId: Number(ccaAcademicYearId),
                      schoolId: Number(school.id),
                    },
                  )}&ccaStudentRenewalId=${id}`,
                )
              }
              label="Accept"
            >
              <DoneIcon />
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmCcaStudentRenewalButton;
